export default __webpack_public_path__ + "static/media/Video_Icon.ad8422db.svg";